import type { Task } from '@/types';

export interface TaskCompletionActionState {
    label: 'Mark as Active' | 'Mark as Complete';
    nextCompleted: boolean;
}

export const getTaskCompletionActionState = (
    tasks: ReadonlyArray<Pick<Task, 'completed'>>,
): TaskCompletionActionState => {
    const allCompleted = tasks.length > 0 && tasks.every((task) => task.completed);

    return {
        label: allCompleted ? 'Mark as Active' : 'Mark as Complete',
        nextCompleted: !allCompleted,
    };
};
